import { createSlice } from "@reduxjs/toolkit"

const initialState = {
  cvCredits: null,
  jobAdvertCredits: null,
  earliestExpiryDate: null,
  cvTokensExpiringSoon: 0,
}


const creditSlice = createSlice({
  name: "credit",
  initialState,
  reducers: {
    setCredits: (state, action) => {
      const payload = action.payload
      state.cvCredits = payload.cvCredits
      state.jobAdvertCredits = payload.jobAdvertCredits
      state.earliestExpiryDate = payload.earliestExpiryDate
      state.cvTokensExpiringSoon = payload.cvTokensExpiringSoon
    },
    resetCreditSlice: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
  },
})

export const { setCredits, resetCreditSlice } = creditSlice.actions

export const selectAvailableTokens = (state) => state.credit.cvCredits;

export default creditSlice.reducer
